export const actionsText = {
    vaccines: { single: 'Agendar vacina', plural: 'Agendar vacinas' },
    exams: { single: 'Agendar exame', plural: 'Agendar exames' },
}

export * from './brands'
export * from './paths'
